module.exports = __webpack_public_path__ + "static/is-snooping-software-our-next-normal-50ddd89ca6ee1b635bdeff12423cf67f.png";